var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1171_1886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.078 4.27829C21.0406 6.24085 22.1432 8.90266 22.1432 11.6782C22.1432 14.4536 21.0406 17.1154 19.078 19.078C17.1155 21.0406 14.4537 22.1431 11.6782 22.1431C8.9027 22.1431 6.24089 21.0406 4.27832 19.078",
    fill: "#FFB6BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6782 22.1445C17.4586 22.1445 22.1446 17.4586 22.1446 11.6781C22.1446 5.89771 17.4586 1.21175 11.6782 1.21175C5.89776 1.21175 1.21179 5.89771 1.21179 11.6781C1.21179 17.4586 5.89776 22.1445 11.6782 22.1445Z",
    stroke: "#3D0E6B",
    strokeWidth: 2.74833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0846 19.0736L25.7986 25.7877",
    stroke: "#3D0E6B",
    strokeWidth: 2.74833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1171_1886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.37,
    height: 27.37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.c288c4e807934bfae9142c8c22460367.svg";
export { ForwardRef as ReactComponent };